module.exports = __webpack_public_path__ + "static/media/filters.8957eeba.svg";